/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerSegmentsSearchQueryResponse, PntSegmentsControllerSegmentsSearchPathParams, PntSegmentsControllerSegmentsSearchQueryParams } from "../models/PntSegmentsControllerSegmentsSearch";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntSegmentsControllerSegmentsSearch } from "../axios/pntSegmentsControllerSegmentsSearch";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntSegmentsControllerSegmentsSearchQueryKey = (slug: PntSegmentsControllerSegmentsSearchPathParams["slug"], params: PntSegmentsControllerSegmentsSearchQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/search', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntSegmentsControllerSegmentsSearchQueryKey = ReturnType<typeof pntSegmentsControllerSegmentsSearchQueryKey>

export function pntSegmentsControllerSegmentsSearchQueryOptions(slug: PntSegmentsControllerSegmentsSearchPathParams["slug"], params: PntSegmentsControllerSegmentsSearchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntSegmentsControllerSegmentsSearchQueryKey(slug, params)
        return queryOptions<PntSegmentsControllerSegmentsSearchQueryResponse, ResponseErrorConfig<Error>, PntSegmentsControllerSegmentsSearchQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntSegmentsControllerSegmentsSearch(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Search segment transcriptions for given terms within a date range.
 * {@link /pnt/v2/segments/:slug/search}
 */
export function usePntSegmentsControllerSegmentsSearch<TData = PntSegmentsControllerSegmentsSearchQueryResponse, TQueryData = PntSegmentsControllerSegmentsSearchQueryResponse, TQueryKey extends QueryKey = PntSegmentsControllerSegmentsSearchQueryKey>(slug: PntSegmentsControllerSegmentsSearchPathParams["slug"], params: PntSegmentsControllerSegmentsSearchQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntSegmentsControllerSegmentsSearchQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntSegmentsControllerSegmentsSearchQueryKey(slug, params)
         

         const query = useQuery({
          ...pntSegmentsControllerSegmentsSearchQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}